import React, { useEffect } from "react";
import styled from "styled-components";
import { HasInitValueBox } from "../../../../AlimTalk/AlimTalkModal";
import { FixedBox } from "../../../../AlimTalk/AlimTalkModal/TemplatePreviewBox";
import { ModalRow } from "../../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";
import { ViewDetail } from "../../PopupTemplate/PopupTemplateModal/PopupDetailSection";

interface PopupPreviewSectionProps {
  previewValue: {
    title: string;
    content: string;
    detail: string;
    buttonName: string;
    buttonLink: string;
  };
  previewBtnValue: {
    buttonName: string;
    buttonLink: string;
  };
}

export default function PopupPreviewSection({
  previewValue,
  previewBtnValue,
}: PopupPreviewSectionProps) {
  const markup = () => {
    if (previewValue?.detail !== "") {
      return { __html: previewValue?.detail };
    }
  };

  useEffect(() => {
    console.log(previewValue);
  }, [previewValue]);

  useEffect(() => {
    console.log(previewBtnValue);
  }, [previewBtnValue]);

  return (
    <PopupPreviewSectionContainer>
      <ModalLabel>미리보기</ModalLabel>

      <FixedBox>
        <strong>{previewValue?.title?.replace("\\n", "\n")}</strong>

        {previewValue?.content !== "" ? `\n\n${previewValue?.content}` : ``}
      </FixedBox>

      {previewValue?.detail &&
        previewValue?.detail !== "null" &&
        previewValue?.detail !== "" && (
          <div style={{ marginTop: 20 }}>
            <ModalLabel>상세</ModalLabel>

            <ViewDetail
              dangerouslySetInnerHTML={markup()}
              style={{ height: "auto" }}
            />
          </div>
        )}

      {previewValue?.content !== "" && (
        <ModalRow style={{ marginTop: 20 }}>
          <ModalLabel>버튼명</ModalLabel>

          <HasInitValueBox style={{ width: 230 }}>
            {previewBtnValue?.buttonName !== ""
              ? previewBtnValue?.buttonName
              : "확인"}
          </HasInitValueBox>
        </ModalRow>
      )}

      {previewValue?.content !== "" && previewBtnValue?.buttonLink !== "" && (
        <>
          <ModalRow style={{ marginTop: 20 }}>
            <ModalLabel>웹 버튼 링크</ModalLabel>

            <HasInitValueBox style={{ width: 230 }}>
              {previewBtnValue?.buttonLink?.split(",")[0] ?? ""}
            </HasInitValueBox>
          </ModalRow>

          <ModalRow style={{ marginTop: 20 }}>
            <ModalLabel>앱 버튼 링크</ModalLabel>

            <HasInitValueBox style={{ width: 230 }}>
              {previewBtnValue?.buttonLink?.split(",")[1] ?? ""}
            </HasInitValueBox>
          </ModalRow>
        </>
      )}
    </PopupPreviewSectionContainer>
  );
}

const PopupPreviewSectionContainer = styled.div`
  margin-bottom: 40px;
`;
